export const PORTAL = {
  apiHost: "https://pcde.tdsapi.com",
  currencySymbolInFront: true,
  decimalSeparator: ",",
  decimalZerosReplacement: "",
  defaultLanguage: "de",
  id: "deTelecom",
  showCreditWarning: false,
  unicodeCurrencySymbol: "\u20ac",
  voiceCreditsInHours: false
};
